import React from "react";
import Navbar from "./Navbar";


function MainWrapper({Component}) {
  return (
    <>
      {/*  Main wrapper second part */}
      <div className="body-wrapper">
           <Navbar />

        <div className="container-fluid">
          <div className="col-sm-6 col-md-12">
          <div className="row">{Component}</div>
        </div>
        </div>
      </div>
    </>
  );
}

export default MainWrapper;
